/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

import { Tooltip } from '../..';
import { TooltipColumn } from '../types';
import { defaultCellWidth, defaultTooltipPosition } from '../constants';

interface Props<D extends object> {
    cell: Cell<D>;
    column: TooltipColumn<D>;
}

export function TruncatedTwoRowCell<D extends object>({
    cell,
    column,
}: Props<D>): JSX.Element {
    const position = column?.tooltipPosition ?? defaultTooltipPosition;
    const width = (column?.width as number) ?? defaultCellWidth;

    return (
        <Tooltip
            message={cell.value}
            position={position}
            minWidth={250}
            maxWidth={250}
        >
            <div className="flex items-center">
                <div
                    className="respond-to-mouse leading-tight clamp-2-lines-break-words"
                    style={{
                        width: width - 10,
                    }}
                >
                    {cell.value}
                </div>
            </div>
        </Tooltip>
    );
}
